// extracted by mini-css-extract-plugin
export var wrapper = "styles-module--wrapper--mYvNy";
export var arrow = "styles-module--arrow--hBORe";